import detectMobile from '../helpers/detect-mobile';

const docforminputEls = document.querySelectorAll('.forminput');

const forminputValid = (elParent, elInput, showError) => {
	const isValid = elInput.checkValidity();
	let elErrMsg = elParent.querySelector('.forminput-floaterror');
	if (isValid) {
		if (elErrMsg) {
			elErrMsg.parentNode.removeChild(elErrMsg);
		}
		elParent.classList.remove('forminput--invalid');
		return true;
	}
	if (showError === false) {
		return null;
	}
	if (!elErrMsg) {
		elErrMsg = document.createElement('span');
		elErrMsg.setAttribute('class', 'forminput-floaterror');
		elParent.appendChild(elErrMsg);
	}
	elErrMsg.textContent = (() => {
		if (elInput.value.length === 0) return 'This field is required.';
		switch (elInput.type) {
		case 'email':
			return 'Please enter an email address.';
		default:
			break;
		}
		return 'Please enter a valid value.';
	})();
	elParent.classList.add('forminput--invalid');
	return false;
};

// mark .forminput elements as 'dirty' if their values are set
const markDirty = (elParent, elInput) => {
	if (elInput.value === '') {
		elParent.classList.remove('forminput--dirty');
	} else {
		elParent.classList.add('forminput--dirty');
	}
};

// lots of forminput listeners
for (let j = docforminputEls.length - 1; j >= 0; j -= 1) {
	const parentEl = docforminputEls[j];
	const forminputEl = parentEl.querySelector('[name]');

	forminputEl.addEventListener('keydown', () => {
		markDirty(parentEl, forminputEl);
		forminputValid(parentEl, forminputEl, false);
	});

	forminputEl.addEventListener('change', () => {
		markDirty(parentEl, forminputEl);
		forminputValid(parentEl, forminputEl, false);
	});

	forminputEl.addEventListener('blur', () => {
		markDirty(parentEl, forminputEl);
	});

	parentEl.addEventListener('click', () => {
		forminputEl.focus();
	});
}


// [type=file]
const uploadEls = document.querySelectorAll('[data-forminput=upload]');
for (let j = uploadEls.length - 1; j >= 0; j -= 1) {
	const uploadInputEl = uploadEls[j].querySelector('[type=file]');
	const visibleInputEl = uploadEls[j].querySelector('[type=text]');

	const setVisibleText = () => {
		visibleInputEl.setAttribute('value', (() => {
			const fake_path = uploadInputEl.value;
			return fake_path.split('\\').pop();
		})());
	};
	uploadInputEl.addEventListener('change', setVisibleText);
	uploadInputEl.addEventListener('focus', setVisibleText);
}

// export validate form funct
const validateForm = (formEl) => {
	const forminputEls = formEl.querySelectorAll('.forminput');
	let isFormValid = true;
	for (let j = forminputEls.length - 1; j >= 0; j -= 1) {
		const elInput = forminputEls[j].querySelector('[name]');
		const isInputValid = forminputValid(forminputEls[j], elInput, true);
		isFormValid = isFormValid && isInputValid;
	}
	return isFormValid;
};

export default { validateForm };
